import { CommunicationsPageProvider } from '../pages/Communications/context/CommunicationsPageContext';
import Communications from '../pages/Communications';

const CommunicationsPageContainer = () => (
  <CommunicationsPageProvider>
    <Communications />
  </CommunicationsPageProvider>
);

export default CommunicationsPageContainer;
